/**
 * Interview Scheduling API V2 [interview-api micro service]
 * @namespace InterviewV2API
 *
 * Crafted By Rami Mustaklem
 */
window.InterviewV2API =  new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    var url = publicConfiguration.getBaseAPI("InterviewServers");
    _protected.setApiUrl(url);

    /**
     * Console an Error
     * @private
     * @type function
     * @param {string.<required, type, key, payload>, null, undefined} errorType
     */
    var errorThrower = function (errorType) {
        var errorMsg = '';

        switch (errorType) {
            case 'required':
                errorMsg = 'Missing parameter for API method';
                break;

            case 'type':
                errorMsg = 'Incompatible parameter type for API method';
                break;

            case 'key':
                errorMsg = 'Missing parameter key for API method';
                break;

            case 'payload':
                errorMsg = 'Missing payload for API method';
                break;

            default:
                errorMsg = 'Error calling API method';
        }

        throw new Error(errorMsg + ', At: ' + Date.now());
    };

    /**
     * Get calendars Settings
     * @public
     * @type function
     * @param
     * @return {Object} promise
     */
    self.getCalendarsSettings = function () {

        var deferred = $q.defer();

        _protected.request('calendars', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * syncCalendar : enable or disable calendar
     * Note : Don't Enable GOOGLE Calender using this Please use hGoogleCalenderConnectBtn Directive
     * @param interviewSetId
     * @param (string) calendarType , (boolean) isEnabled
     * @param message
     */
    self.syncCalendar = function (calendarType, isEnabled) {

        if (!calendarType) {
            errorThrower('required');
        }
        var syncStatus = isEnabled ? 'enable' : 'disable';

        var deferred = $q.defer();

        _protected.request('calendars/' + calendarType + '/' + syncStatus, 'POST')
            .then(function (result) {
                deferred.resolve(result.data.data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get list of message templates by Brand Id
     * @public
     * @type function
     * @memberOf InterviewV2API#getBrandMessageTemplates
     * @param {number} brandId
     * @return {Object} promise
     */
    self.getBrandMessageTemplates = function (brandId, type, category, positionCode) {
        if (!brandId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }
        var params = {};
        if (type) {
            params['types'] = Array.isArray(type) ? type.join(",") : type;
        }

        if (category) {
            params['category'] = category;
        }

        if (positionCode) {
            params['position_code'] = positionCode;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/message_templates', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /** GET message templates smart fields
     *  @public
     *  @type function
     *  @memberOf InterviewV2API
     *  @return {Object} promise
     */

    self.getMessageTemplateSmartFields = (params) => {
        const deferred = $q.defer();

        _protected.request('message_templates/smart_fields', 'GET', params)
            .then((res) => {
                if (res?.data?.data && res.status === 200) {
                    deferred.resolve(res.data.data.smart_fields);
                } else {
                    deferred.reject(res);
                }
            })
            .catch((err) => {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get list of job interviewers by Brand Id
     * @public
     * @type function
     * @memberOf InterviewV2API#getJobInterviewers
     * @param {number} brandId
     * @param {number} jobId
     * @return {Object} promise
     */
    self.getJobInterviewers = function (brandId, jobId,payload) {

        if (!brandId || !jobId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interviewers', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Save job application interviewers
     * @public
     * @type function
     * @memberOf InterviewV2API#saveJobApplicationInterviewers
     * @param {number} brandId
     * @param {number} jobId
     * @param {Array.<{string,number}>} payload
     * @return {Object} promise
     */
    self.saveJobApplicationInterviewers = function (brandId, jobId, payload) {

        if (!brandId || !jobId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId))) {
            errorThrower('type');
        }

        var deferred = $q.defer();


        _protected.request(self.apiUrl.replace('v1', 'v2')+'brands/' + brandId + '/jobs/' + jobId + '/interviewers', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get a Job's Interviewers' NOT Available Slots
     * @public
     * @type function
     * @memberOf InterviewV2API#getJobInterviewersAvailabilities
     * @param {number} brandId
     * @param {number} jobId
     * @param {Array.<number>} userIds
     * @param {Date} fromTime
     * @param {Date, null, undefined} [toTime] - optional parameter
     * @param {String} type=AVAILABLE|BOOKED - possible values are BOOKING || AVAILABLE
     * @return {Object} promise
     */
    self.getJobInterviewersAvailabilities = function (brandId, jobId, userIds, fromTime, toTime, type) {

        if (!brandId || !jobId || !fromTime) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId))) {
            errorThrower('type');
        }

        if (!fromTime instanceof Date || isNaN(Date.parse(fromTime.toISOString()))) {
            errorThrower('type');
        }

        if (toTime && (!toTime instanceof Date || isNaN(Date.parse(toTime.toISOString())))) {
            errorThrower('type');
        }

        if (!userIds || !userIds.length) {
            errorThrower('payload');
        }

        var deferred = $q.defer();

        var payload = {
            user_ids: userIds,
            from_time: fromTime.toISOString(),
            type: type
        };

        if (toTime) {
            payload['to_time'] = toTime.toISOString();
        }

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interviewers/slots', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get a Job's Interviewers' Available/Booked Slots V2
     * @public
     * @type function
     * @memberOf InterviewV2API#getJobInterviewersAvailabilitiesV2
     * @param {number} brandId
     * @param {Array.<number>} userIds
     * @param {Date} fromTime
     * @param {Date, null, undefined} [toTime] - optional parameter
     * @param {String} type=AVAILABLE|BOOKED - possible values are BOOKING || AVAILABLE
     * @return {Object} promise
     */
    self.getJobInterviewersAvailabilitiesV2 = function (brandId, userIds, fromTime, toTime, type) {

        if (!brandId || !fromTime) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }

        if (!fromTime instanceof Date || isNaN(Date.parse(fromTime.toISOString()))) {
            errorThrower('type');
        }

        if (toTime && (!toTime instanceof Date || isNaN(Date.parse(toTime.toISOString())))) {
            errorThrower('type');
        }

        if (!userIds || !userIds.length) {
            errorThrower('payload');
        }

        var deferred = $q.defer();

        var payload = {
            user_ids: userIds,
            from_time: fromTime.toISOString(),
            type: type
        };

        if (toTime) {
            payload['to_time'] = toTime.toISOString();
        }

        _protected.request('brands/' + brandId + '/interviewers/slots', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get Application Status Details
     * @public
     * @type function
     * @memberOf InterviewV2API#getApplicationStatusDetails
     * @param {number} brandId
     * @param {number} jobId
     * @param {number} appId
     * @return {Object} promise
     */
    self.getApplicationStatusDetails = function (brandId, jobId, appId, type) {

        if (!brandId || !jobId || !appId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId)) || isNaN(parseInt(appId))) {
            errorThrower('type');
        }

        var params = {};
        if (type) {
            params['type'] = type;
        }
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/applications/' + appId, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get a specific job's interview sets meta information
     * If AQAAF - Get a specific AQAAF job's interview set details
     * @public
     * @type Function
     * @memberOf InterviewV2API#getJobInterviewSetsInfo
     * @param {Number} brandId
     * @param {Number} jobId
     * @param {Boolean=} AQAAF
     * @return {Object} promise
     */
    self.getJobInterviewSetsInfo = function (brandId, jobId, AQAAF, type) {

        if (!brandId || !jobId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId))) {
            errorThrower('type');
        }

        if (AQAAF && typeof (AQAAF) !== "boolean") {
            errorThrower('type');
        }

        var params = {};
        if (type) {
            params['type'] = type;
        }

        var deferred = $q.defer();

        var endpointDetails = AQAAF? "aqaaf": "meta";

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/' + endpointDetails, 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Withdraw interview
     * @param brandId
     * @param jobId
     * @param appIds
     */
    self.withdrawInterview = function (brandId, jobId, appIds, type) {

        if (!brandId || !jobId || !appIds || !appIds.length) {
            errorThrower('required');
        }

        var params = {
            application_ids: appIds
        };

        if (type) {
            params['type'] = type;
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/applications/withdraw', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get Interview Applicants Statuses
     * @public
     * @type function
     * @memberOf InterviewV2API#getInterviewApplicantsStatuses
     * @param {number} brandId
     * @param {number} jobId
     * @param {Array.<number>} applicantIds
     * @return {Object} promise
     */
    self.getInterviewApplicantsStatuses = function (brandId, jobId, applicantIds) {

        if (!brandId || !jobId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId))) {
            errorThrower('type');
        }

        if (!applicantIds || !applicantIds.length) {
            errorThrower('payload');
        }

        var deferred = $q.defer();
        var idsPerReq = 200;
        var numberOfIds = applicantIds.length;
        var numberOfNeededRequests = Math.ceil(numberOfIds / idsPerReq);

        var requests = [];

        for (var i = 0; i < numberOfNeededRequests; i++) {
            var params = {
                'ids': applicantIds.slice(i * idsPerReq, (i + 1) * idsPerReq).join()
            };
            requests.push(_protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/applications/statuses', 'GET', params));
        }

        $q.all(requests)
            .then(function (result) {
                var data = {applications: []};

                for (var i in result) {
                    if (result[i] && result[i].data && result[i].data.data) {
                        data['applications'] = data['applications'].concat(result[i].data.data['applications'] || []);
                    }
                }

                deferred.resolve(data);

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
    /**
     * get job interview sets and open days
     * @param brandId
     * @param jobId
     * @param interviewersIds
     * @param appStatus
     * @param offset
     * @param limit
     */
    self.getJobInterviewSets = function (brandId, jobId, interviewersIds, appStatus, types, offset, limit) {

        if (!brandId || !jobId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {};

        params.offset = offset || 0;
        params.limit = limit || 99999;

        if (appStatus) {
            params.application_status = appStatus;
        }

        params.interviewers_ids = interviewersIds;
        params.types = types;

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets', 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get the number of interview sets
     * @param brandId
     * @param jobId
     */

    self.getJobInterviewSetsCounts = function (brandId, jobId) {

        if (!brandId || !jobId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/applications/counts', 'GET')
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get accessed brands with their jobs
     * @param brandId
     * @param fromTime moment
     * @param toTime moment
     */
    self.getLocationsWithJobs = function (brandId, fromTime, toTime, includeArchived) {

        if (!brandId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {
            from_time: fromTime,
            to_time: toTime,
            include_archived: !!includeArchived
        };

        _protected.request('brands/' + brandId + '/jobs', 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    self.getLocationsForHMAP = function () {

        var deferred = $q.defer();
        _protected.request('users/brands?application_status=CONFIRMED', 'GET', {})
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get all details related to a specific interview set
     * @public
     * @type Function
     * @memberOf InterviewV2API#getInterviewSetDetails
     * @param {Number} brandId
     * @param {Number} jobId
     * @param {Number} interviewSetId
     * @return {Object} promise
     */
    self.getInterviewSetDetails = function (brandId, jobId, interviewSetId) {

        if (!brandId || !jobId || !interviewSetId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(jobId)) || isNaN(parseInt(interviewSetId))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/' + interviewSetId, 'GET')
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * change interview set slot candidate attendance
     * @param brandId
     * @param jobId
     * @param interviewSetId
     * @param appId
     * @param attendance
     */
    self.updateInterviewSetAttendance = function (brandId, jobId, interviewSetId, appId, attendance) {

        if (!brandId || !jobId || !interviewSetId || !appId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {
            attendance: attendance
        };

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/' + interviewSetId + '/applications/' + appId, 'PUT', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * This API to get the confirmed slots to view them on the calendar view after expansion
     * @param brandId
     * @param filters
     */
    self.getConfirmedInterviewsSlots = function (brandId, filters) {

        if (!brandId) {
            errorThrower('required');
        }
        var deferred = $q.defer();
        var url = 'brands/' + brandId + '/interview_sets/slots';

        _protected.request(url, 'GET', filters)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getUsersInterviewsSlots = function (filters) {

        var deferred = $q.defer();
        var url = 'users/interview_sets/slots';

        _protected.request(url, 'GET', filters)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get interview sets for the manifest page
     * @param brandId
     * @param filters
     */
    self.getManifestInterviewSets = function (brandId, filters) {

        if (!brandId) {
            errorThrower('required');
        }

        var requestUrl = 'brands/' + brandId + '/interview_sets/applications';

        var deferred = $q.defer();

        _protected.request(requestUrl, 'GET', filters)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get interview sets for the manifest page
     * @param brandId
     * @param filters
     */
    self.getUserManifestInterviewSets = function (brandId, filters,isAllLocations) {

        if (!brandId) {
            errorThrower('required');
        }

        var requestUrl = 'users/interview_sets/applications';

        if(!isAllLocations){
            filters.brand_ids = [brandId];
        }


        var deferred = $q.defer();

        _protected.request(requestUrl, 'GET', filters)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get the applications of open days and interviews sets
     * @public
     * @type function
     * @memberOf InterviewV2API#getInterviewSetApplications
     * @param brandId
     * @param interviewSetId
     * @param status
     * @return {Object} promise
     */
    self.getInterviewSetApplications = function (brandId, interviewSetId, status) {

        if (!brandId || !interviewSetId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {
            status: status
        };

        _protected.request('brands/' + brandId + '/interview_sets/' + interviewSetId + '/applications', 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    /**
     * Get the applications of open days and interviews sets
     * @public
     * @type function
     * @memberOf InterviewV2API#getInterviewSetApplicationsV2
     * @param brandId
     * @param interviewSetId
     * @param status
     * @return {Object} promise
     */
    self.getInterviewSetApplicationsV2 = function (brandId, interviewSetId, status) {

        if (!brandId || !interviewSetId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {
            status: status
        };

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'brands/' + brandId + '/interview_sets/' + interviewSetId + '/applications', 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get interview sets open days or manifest open days for enterprise level
     * Depending on a specific flag - [if there is a job id then we need a specific open day set]
     * @public
     * @type function
     * @memberOf InterviewV2API#getBrandOpenDays
     * @param {Number} brandId
     * @param {Number=} jobId
     * @param {Date=} fromTime
     * @param {Date=} toTime
     * @param {Boolean=} includeChildren
     * @param {String=} status
     * @param {Number=} filterByJobId
     * @param {Number=} interviewerUserId
     * @param {Array<Number>=} brandIds
     *
     * @exception Either includeChildren flag is provided or brandIds filter is used || jobId provided for specific job
     */
    self.getBrandOpenDays = function (brandId, jobId, fromTime, toTime, includeChildren, status, filterByJobId, interviewerUserId, brandIds, includeArchived) {

        if (!brandId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }

        if (fromTime && (!fromTime instanceof Date || isNaN(Date.parse(fromTime.toISOString())))) {
            errorThrower('type');
        }

        if (toTime && (!fromTime instanceof Date || isNaN(Date.parse(toTime.toISOString())))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        var endpointDetails = jobId? '/jobs/' + jobId + '/interview_sets' : '/manifest';
        var url = 'brands/' + brandId + endpointDetails + '/open_days';

        var payload = {};

        if (fromTime) payload['from_time'] = fromTime.toISOString();
        if (toTime) payload['to_time'] = toTime.toISOString();
        if (includeChildren) payload['include_children'] = includeChildren;
        if (status) payload['application_status'] = status;
        if (jobId) payload['job_id'] = filterByJobId;
        if (interviewerUserId) payload['interviewer_user_id'] = interviewerUserId;
        if (brandIds && brandIds.length) payload['brand_ids'] = brandIds;

        if (url.includes('/open_days')) {
            payload['include_archived'] = !!includeArchived;
        }

        _protected.request(url, 'GET', payload)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    /**
     * Get interview sets open days or manifest open days for enterprise level
     * Depending on a specific flag - [if there is a job id then we need a specific open day set]
     * @public
     * @type function
     * @memberOf InterviewV2API#getBrandOpenDays
     * @param {Number} brandId
     * @param {Number=} jobId
     * @param {Date=} fromTime
     * @param {Date=} toTime
     * @param {Boolean=} includeChildren
     * @param {String=} status
     * @param {Number=} filterByJobId
     * @param {Number=} interviewerUserId
     * @param {Array<Number>=} brandIds
     *
     * @exception Either includeChildren flag is provided or brandIds filter is used || jobId provided for specific job
     */
    self.getUserManifestOpenDays = function (brandId, jobId, fromTime, toTime, includeChildren, status, filterByJobId, interviewerUserId, brandIds) {

        if (!brandId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }

        if (fromTime && (!fromTime instanceof Date || isNaN(Date.parse(fromTime.toISOString())))) {
            errorThrower('type');
        }

        if (toTime && (!fromTime instanceof Date || isNaN(Date.parse(toTime.toISOString())))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        var url = 'users/manifest/open_days';

        var payload = {};

        if (fromTime) payload['from_time'] = fromTime.toISOString();
        if (toTime) payload['to_time'] = toTime.toISOString();
        if (includeChildren) payload['include_children'] = includeChildren;
        if (status) payload['application_status'] = status;
        if (jobId) payload['job_id'] = filterByJobId;
        if (interviewerUserId) payload['interviewer_user_id'] = interviewerUserId;
        if (brandIds && brandIds.length) payload['brand_ids'] = brandIds;

        _protected.request(url, 'GET', payload)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Return open days for enterprise only on dashboard on click manage open day
     *
     * @memberOf InterviewV2API#getBrandOpenDayEnterpriseDashboard
     * @param brandId
     * @param fromTime
     * @param toTime
     */
    self.getBrandOpenDayEnterpriseDashboard = function (brandId, fromTime, toTime) {

        if (!brandId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }

        if (fromTime && (!fromTime instanceof Date || isNaN(Date.parse(fromTime.toISOString())))) {
            errorThrower('type');
        }

        if (toTime && (!fromTime instanceof Date || isNaN(Date.parse(toTime.toISOString())))) {
            errorThrower('type');
        }

        var payload = {};

        if (fromTime) {
            payload['from_time'] = fromTime.toISOString();
        }

        if (toTime) {
            payload['to_time'] = toTime.toISOString();
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/interview_sets/open_days', 'GET', payload)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    /**
     * Request new time for an interview in candidate side.
     * @param interviewSetId
     * @param appId
     * @param message
     */
    self.requestNewTimeForInterview = function (interviewSetId, appId, message) {

        if (!interviewSetId || !appId) {
            errorThrower('required');
        }

        var params = {
            message: message
        };

        var deferred = $q.defer();

        _protected.request('candidates/interview_sets/' + interviewSetId + '/applications/' + appId + '/request_new_time', 'POST', params)
            .then(function (result) {
                deferred.resolve(result.data.data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * decline an interview in candidate side.
     * @param interviewSetId
     * @param appId
     * @param message
     */
    self.declineInterview = function (interviewSetId, appId, message) {

        if (!interviewSetId || !appId) {
            errorThrower('required');
        }

        var params = {
            message: message
        };

        var deferred = $q.defer();

        _protected.request('candidates/interview_sets/' + interviewSetId + '/applications/' + appId + '/decline', 'POST', params)
            .then(function (result) {
                deferred.resolve(result.data.data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get Candidate interview slots
     * @param mode
     * @param statuses
     * @param fromTime
     * @param toTime
     */
    self.getCandidateInterviewApplications = function (mode, statuses, fromTime, toTime) {

        var deferred = $q.defer();

        var params = {
            mode: mode,
            statuses: statuses,
            from_time: fromTime,
            to_time: toTime
        };

        _protected.request('candidates/interview_sets/applications', 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getInterviewApplicationCalenderInvite = function (interviewSetId, appId, soltId) {

        if (!interviewSetId || !appId) {
            errorThrower('required');
        }

        var params = {
            slot_ids: soltId
        };

        var deferred = $q.defer();

        _protected.request('candidates/interview_sets/' + interviewSetId + '/applications/' + appId + '/calendar', 'GET', params)
            .then(function (result) {
                deferred.resolve(result.data);
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };



    /**
     * Send OPEN_DAY invite to candidate
     * @public
     * @type Function
     * @memberOf InterviewV2API#sendOpendayInvite
     * @param {Number} brandId
     * @param {Number} jobId
     * @param {Number} interviewSetId
     * @param {Array:<Number>} userAppsIds
     * @return {Object} promise
     */
    self.sendOpendayInvite = function (brandId, jobId, interviewSetId, userAppsIds) {

        var deferred = $q.defer();

        var params = {
            applications: userAppsIds
        };

        _protected.uniqueRequest('brands/' + brandId +  '/jobs/' + jobId + '/interview_sets/' + interviewSetId + '/applications', 'POST', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };


    /**
     * get application details in candidate side
     * @param appId
     * @param slotType
     */
    self.getApplicationDetails = function (appId, slotType, interviewType) {

        if (!appId || !slotType) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {
            slot_type: slotType,
            interview_type: interviewType
        };

        _protected.request('candidates/interview_sets/applications/' + appId, 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * confirm interview invite in candidate side.
     * @param interviewSetId
     * @param appId
     * @param slotId
     */
    self.confirmApplication = function (interviewSetId, appId, slotId) {

        if (!interviewSetId || !appId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        var params = {};

        if (slotId) {
            params.slot_id = slotId;
        }

        _protected.request('candidates/interview_sets/' + interviewSetId + '/applications/' + appId + '/confirm', 'POST', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * add new open day
     * @param brandId
     * @param opendayData
     */
    self.addOpenday = function (brandId, opendayData) {

        if (!brandId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        _protected.uniqueRequest('brands/' + brandId + '/interview_sets', 'POST', opendayData)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     *
     * @param brandId
     * @param opendayData
     */
    self.updateOpenday = function (brandId, opendayId, opendayData) {

        if (!brandId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/interview_sets/' + opendayId, 'PUT', opendayData)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * delete open day
     * @param brandId
     * @param opendayId
     */
    self.deleteOpenday = function (brandId, opendayId) {

        if (!brandId || !opendayId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/interview_sets/open_days/' + opendayId, 'DELETE')
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * get open day details
     * @param brandId
     * @param opendayId
     */
    self.getOpenday = function (brandId, opendayId) {

        if (!brandId || !opendayId) {
            errorThrower('required');
        }

        var deferred = $q.defer();
        _protected.request('brands/' + brandId + '/interview_sets/open_days/' + opendayId, 'GET')
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * update the status to no show
     * @param brandId
     * @param jobId
     * @param interviewSetId
     * @param appId
     * @param params
     */
    self.updateInterviewAttendance = function (brandId, jobId, interviewSetId, appId, params) {

        if (!brandId) {
            errorThrower('required');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/' + interviewSetId + '/applications/' + appId, 'GET', params)
            .then(function (result) {
                if (result.data) {
                    deferred.resolve(result.data.data);
                } else {
                    deferred.reject(result);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Post a new template message for a brand
     * @type function
     * @name InterviewV2API#addBrandMessageTemplate
     * @param {number} brandId
     * @param {Object.<{title: String, message: String}>} newTemplate
     * @return {Object} promise
     */
    self.addBrandMessageTemplate = function (brandId, newTemplate) {

        if (!brandId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }

        if (!newTemplate) {
            errorThrower('payload');
        } else {
            if (!newTemplate.title || !newTemplate.message) {
                errorThrower('key');
            }
        }

        var deferred = $q.defer();

        var payload = {
            title: newTemplate.title,
            message: newTemplate.message,
            type: newTemplate.type
        };

        if (newTemplate.type) {
            payload['type'] = newTemplate.type;
        }

        if (newTemplate.category) {
            payload['category'] = newTemplate.category;
        }

        _protected.request('brands/' + brandId + '/message_templates', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Update a template message for a brand
     * @type function
     * @name InterviewV2API#updateBrandMessageTemplate
     * @param {number} brandId
     * @param {Object.<{id: number, title: string, message: string}>} oldTemplate
     * @return {Object} promise
     */
    self.updateBrandMessageTemplate = function (brandId, oldTemplate) {

        if (!brandId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId))) {
            errorThrower('type');
        }

        if (!oldTemplate) {
            errorThrower('payload');
        } else {
            if (!oldTemplate.id || !oldTemplate.title || !oldTemplate.message) {
                errorThrower('key');
            }
        }

        var deferred = $q.defer();

        var payload = {
            title: oldTemplate.title,
            message: oldTemplate.message,
            type: oldTemplate.type
        };

        if (oldTemplate.category) {
            payload['category'] = oldTemplate.category;
        }

        _protected.request('brands/' + brandId + '/message_templates/' + oldTemplate.id, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Delete a template message for a brand
     * @type function
     * @name InterviewV2API#deleteBrandMessageTemplate
     * @param {number} brandId
     * @param {number} templateId
     * @return {Object} promise
     */
    self.deleteBrandMessageTemplate = function (brandId, templateId) {

        if (!brandId || !templateId) {
            errorThrower('required');
        }

        if (isNaN(parseInt(brandId)) || isNaN(parseInt(templateId))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/message_templates/' + templateId, 'DELETE')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Get logged in user availability slots
     * @public
     * @type function
     * @memberOf InterviewV2API#getUserAvailabilitySlots
     * @param {Date} fromTime
     * @param {Date, null, undefined=} toTime
     * @return {Object} promise
     */
    self.getUserAvailabilitySlots = function (fromTime, toTime) {

        if (!fromTime) {
            errorThrower('required');
        }

        if (!fromTime instanceof Date || isNaN(Date.parse(fromTime.toISOString()))) {
            errorThrower('type');
        }

        if (toTime && (!fromTime instanceof Date || isNaN(Date.parse(toTime.toISOString())))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        var payload = {
            from_time: fromTime.toISOString()
        };

        if (toTime) {
            payload['to_time'] = toTime.toISOString();
        }

        _protected.request('availabilities', 'GET', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Update logged in user availability slots
     * @public
     * @type function
     * @memberOf InterviewV2API#updateUserAvailabilitySlots
     * @param {Date} fromTime
     * @param {Date} toTime
     * @param {Array.<Object.<{start_time: Date, end_time: Date}>>} slots
     * @param {Boolean, null, undefined} copy
     * @param {number, null, undefined} repeat
     * @return {Object} promise
     */
    self.updateUserAvailabilitySlots = function (fromTime, toTime, slots, copy, repeat) {

        if (!fromTime || !toTime || !slots) {
            errorThrower('required');
        }

        if (!fromTime instanceof Date || !toTime instanceof Date || isNaN(Date.parse(moment(fromTime).toISOString())) || isNaN(Date.parse(moment(toTime).toISOString()))) {
            errorThrower('type');
        }

        if (copy && typeof copy !== 'boolean' && repeat && isNaN(parseInt(repeat))) {
            errorThrower('type');
        }

        var deferred = $q.defer();

        var payload = {
            from_time: Utils.getISODate(moment(fromTime).utc()),
            to_time: Utils.getISODate(moment(toTime).utc()),
            slots: slots
        };

        if (copy && repeat) {
            payload['copy'] = copy;
            payload['number_of_weeks'] = repeat;
        }

        _protected.request('availabilities', 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.updateUserAvailabilitySlotsV2 = function (payload) {
        var deferred = $q.defer();
        var payload = payload || {};

        _protected.request(self.apiUrl.replace('v1', 'v2') + 'availabilities', 'PUT', payload)
            .then(function (res) {
                if (res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }
            })
            .catch(function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Create a new interview set invite for a brand
     * @public
     * @type Function
     * @memberOf InterviewV2API#saveBrandInterviewSet
     * @param brandId
     * @param payload
     */
    self.saveBrandInterviewSet = function (brandId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/interview_sets', 'POST', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    /**
     * Update a specific brand interview set
     * @public
     * @type Function
     * @memberOf InterviewV2API#updateBrandInterviewSet
     * @param brandId
     * @param interviewSetId
     * @param payload
     */
    self.updateBrandInterviewSet = function (brandId, interviewSetId, payload) {

        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/interview_sets/' + interviewSetId, 'PUT', payload)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getReportsInterviewV2Settings = function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/INTERVIEW_V2/children/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getFeasibleCandidates = function (brandId, jobId, interviewType) {
        var deferred = $q.defer();
        var params = {};
        if (interviewType) {
            params['type'] = interviewType;
        }

        _protected.request('brands/' + brandId + '/jobs/' + jobId + '/interview_sets/applications/feasible', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data.applications);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
  
    self.getSettings =function (brandId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/services/INTERVIEW_V2/settings', 'GET')
            .then(function (res) {
                if (res && res.data && res.data.data && res.status === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };
};

/**
 * Interview possible status values
 * @type {{CONFIRMED: string, DENIED: string, SENT: string, NEW_TIME_REQUESTED: string}}
 * @name InterviewV2API#INTERVIEW_STATUS
 */
InterviewV2API.INTERVIEW_STATUSES = {
    CONFIRMED: 'CONFIRMED',
    SENT: 'SENT',
    NOT_SENT: 'NOT_SENT', // Default status. From FE
    DENIED: 'DENIED',
    WITHDRAWN: 'WITHDRAWN',
    REQUEST_NEW_TIME: 'TIME_REQUESTED'
};

InterviewV2API.INTERVIEW_STATUSES_LABEL = {
    CONFIRMED: $filter('translate')('confirmed'),
    SENT: $filter('translate')('sent'),
    NOT_SENT: $filter('translate')('not sent'), // Default status. From FE
    DENIED: $filter('translate')('denied'),
    WITHDRAWN: $filter('translate')('withdrawn'),
    REQUEST_NEW_TIME: $filter('translate')('time requested')
};

InterviewV2API.INTERVIEW_TYPES = {
    VIDEO: 'VIDEO',
    QUESTIONS: 'QUESTIONS'
};

InterviewV2API.ERROR_CODES = {
    CAN_NOT_REMOVE_CONFIRMED_SLOT: 'CAN_NOT_REMOVE_CONFIRMED_SLOT',
    OVERLAP_NOT_ALLOWED: 'OVERLAP_NOT_ALLOWED',
    INTERVIEWERS_HAVE_CONFIRMED_SLOTS: 'INTERVIEWERS_HAVE_CONFIRMED_SLOTS',
    SLOT_DOES_NOT_MATCH_DURATION: 'SLOT_DOES_NOT_MATCH_DURATION',
}